import { render } from "./not-found.vue?vue&type=template&id=fdd2ca60&scoped=true"
import script from "./not-found.vue?vue&type=script&lang=js"
export * from "./not-found.vue?vue&type=script&lang=js"

import "./not-found.vue?vue&type=style&index=0&id=fdd2ca60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd2ca60"]])

export default __exports__